// extracted by mini-css-extract-plugin
export default {"container":"NpsScoreInputs_container__LXqWv","text":"NpsScoreInputs_text__QX667"};